import AuthModule from '../storeModules/auth';

export default {
  install(Vue, { store }) {
    /**
     * Deve essere necessariamente passata l'istanza di vuex store
     */
    if(!store) {
      throw new Error("Please provide vuex store");
    }

    /**
     * Registrazione del modulo dello store associato al menu
     */
    store.registerModule('auth', AuthModule);
  }
}